import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/header.js";

import Laboratories from "../assets/Laboratories.png";
import Pharmacies from "../assets/Pharmacies.png";
import Star from "../assets/star.svg";

import { AEYDAR_API } from "../constants.js";

import {
  Container,
  ImagesContainer,
  GridImages,
  Review,
  Map,
  InfoContainer,
} from "../styles/hospital/hospital";

const Hospital = () => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({});
  const { place_id } = useParams();

  const getHospitalInfo = async (place_id) => {
    if (!place_id) return;
    setLoading(true);

    const request = await fetch(
      `${AEYDAR_API}/place_details/${place_id}`
    ).catch((error) => {
      console.error(error);
      setLoading(false);
    });

    const information = await request?.json();
    if (information) {
      setLoading(false);
    }
    const result = {
      ...information?.result,
      photo_url: information?.photo_url,
    };
    console.log(result.geometry.location.lat);
    setDetails(result);
  };

  useEffect(
    () => {
      getHospitalInfo(place_id);
    },
    // eslint-disable-next-line
    []
  );
  return (
    <>
      <Header />
      <Container>
        <h1>{details?.name}</h1>
        <p>
          {details?.rating ? (
            <span>
              <img src={Star} alt="" /> {details.rating}
            </span>
          ) : (
            "None"
          )}{" "}
        </p>
        <ImagesContainer>
          <img
            className="leftImage"
            src={
              details?.photo_url?.length === 0
                ? Laboratories
                : details.photo_url
            }
            alt=""
          />
          <GridImages>
            <img
              src={
                details?.photo_url?.length === 0
                  ? Pharmacies
                  : details.photo_url
              }
              alt={loading ? "" : ""}
            />
            <img
              src={
                details?.photo_url?.length === 0
                  ? Pharmacies
                  : details.photo_url
              }
              alt=""
            />
            <img
              src={
                details?.photo_url?.length === 0
                  ? Pharmacies
                  : details.photo_url
              }
              alt=""
            />
            <img
              src={
                details?.photo_url?.length === 0
                  ? Pharmacies
                  : details.photo_url
              }
              alt=""
            />
          </GridImages>
        </ImagesContainer>
        <InfoContainer>
          <span>
            <h4>Address</h4>
            <p>{details?.formatted_address}</p>
            <h4>Open Hours</h4>
            {details?.opening_hours
              ? details.opening_hours.weekday_text.map((item) => {
                  return <p key={item}>{item}</p>;
                })
              : "None Specified"}
            <h4>Phone numbers</h4>
            <p>
              {details?.formatted_phone_number
                ? details.formatted_phone_number
                : "None Specified"}
            </p>

            <h4>Website</h4>
            {details?.website ? (
              <a href={details.website} target="_blank" rel="noreferrer">
                {details.website}
              </a>
            ) : (
              "No website"
            )}
          </span>
          <Map>
            <iframe
              title="map"
              loading="lazy"
              allowFullScreen
              src={`https://www.google.com/maps/embed/v1/view?key=AIzaSyDxt_0pndC4mR72g4IGedAn9uSAHiJjemI&zoom=18&center=${details?.geometry?.location?.lat},${details?.geometry?.location?.lng}`}
            ></iframe>
          </Map>
        </InfoContainer>

        <h4>Reviews</h4>
        <Review>
          {details?.reviews
            ? details.reviews.map((item, key) => {
                return (
                  <>
                    <div key={key}>
                      <p>
                        <img
                          className="user_profile"
                          src={item.profile_photo_url}
                          alt=""
                        />
                      </p>
                      <p>{item.author_name}</p>
                      <p>
                        {" "}
                        <span>
                          <img src={Star} alt="" />
                        </span>{" "}
                        {item.rating}
                      </p>
                      <p>{item.text}</p>
                      <p>{item.relative_time_description}</p>
                    </div>
                    <hr />
                  </>
                );
              })
            : "No reviews"}
        </Review>
      </Container>
    </>
  );
};

export default Hospital;
